import { MdCheck } from 'react-icons/md'
import Input from 'shared/components/Input'
import { colors } from 'shared/styles/colors'
import dimensions from 'shared/styles/dimensions'
import styled from 'styled-components'

export const StyledCheck = styled(MdCheck)`
  color: ${colors.green};
  font-size: 80px !important;
  padding: 10px 10px 10px 10px;
  border: 3px solid ${colors.green};
  border-radius: 50%;
`

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  padding: 30px 0px;
  color: ${colors.blue};
`

export const Field = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: ${colors.blue};
  margin-bottom: ${dimensions.spaces.small}px;
`
export const StyledError = styled.p`
  width: 100%;
  color: red;
  font-weight: 400;
  font-size: 12px;
`

export const StyledInput = styled(Input)`
  border: none;
  &:disabled {
    background: transparent;

    padding: 0px;

    font-weight: 700;
    height: 10px;
  }
`

export const WrapperRadio = styled.div`
  border: 1px solid ${colors.stepInactive};

  margin-top: 20px;
  padding: 0px 10px 10px;

  width: 343px;
  height: 128px;
`
